<template>

    <div class="container">

        <app-head title="Attachments" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Medien') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.attachments.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name }}</option>
                </select-input>
                <select-input label="attachment_type" v-model="form.attachment_type">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="k" v-for="(v, k) in attachmentTypeOptions">{{ v }}</option>
                </select-input>
                <!--                <select-input label="Attachmentable type" v-model="form.attachmentable_type">
                                    <option :value="null">{{ __('Alle') }}</option>
                                    <option :value="k" v-for="(v, k) in attachmentableTypeOptions">{{ v }}</option>
                                </select-input>-->
                <select-input label="status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="attachments.meta" />
            <div>
                <i class="bi bi-download"></i>
                {{ __('Export') }}
                <a :href="getExportUrl('xlsx')">
                    {{ __('XLSX') }}
                </a>
                /
                <a :href="getExportUrl('csv')">
                    {{ __('CSV') }}
                </a>
                /
                <a :href="getExportUrl('ods')">
                    {{ __('ODS') }}
                </a>
            </div>
        </div>

        <div class="card">
            <data-table :items="attachments.data"
                        :links="attachments.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="attachment in attachments.data" :key="attachment.id">
                    <td>
                        {{ attachment.id }}
                    </td>
                    <td class="text-center">
                        <div v-if="attachment.mime_type === 'application/pdf'">
                            <i class="bi bi-file-earmark-pdf fs-1 text-danger"></i>
                        </div>
                        <div v-else>
                            <img :src="attachment.thumbnail_url" alt="" style="max-width: 100px; max-height: 70px" />
                        </div>
                    </td>
                    <td>
                        <div v-if="attachment.deleted_at">
                            {{ attachment.title || '-' }}
                        </div>
                        <inertia-link :href="route('admin.attachments.edit', attachment)" class="stretched-link" v-else>
                            {{ attachment.title || '-' }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ attachment.attachmentables.length }}
                    </td>
                    <td class="text-nowrap">
                        <div v-if="attachment.size">
                            {{ attachment.size | humanReadableFilesize }}
                        </div>
                        <div v-else>-</div>
                    </td>
                    <td>
                        {{ attachment.purpose || '-' }}
                    </td>
                    <td class="text-nowrap">
                        {{ attachment.updated_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <template v-if="attachment.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(attachment)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(attachment)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <template v-else>
                            <i class="bi bi-chevron-right"></i>
                        </template>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';

    import Results from '@/shared/Admin/Results';

    export default {
        props: [
            'filters',
            'suppliers',
            'attachments',
            'attachmentTypeOptions',
//            'attachmentableTypeOptions',
        ],
        components: {
            TextInput,
            SelectInput,
            DataTable,
            DataTableRow,
            SearchFilter,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    sort: this.filters.sort,
                    direction: this.filters.direction,
                    status: this.filters.status,
                    attachment_type: this.filters.attachment_type,
                    attachmentable_type: this.filters.attachmentable_type,
                    supplier_id: this.filters.supplier_id,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    thumbnail: {label: ''},
                    title: {label: 'Title', sortable: 'title'},
                    attachmentables: {label: 'Verbindungen'},
                    size: {label: 'Size', sortable: 'size'},
                    purpose: {label: 'Purpose'},
                    updated_at: {label: 'Updated', sortable: 'updated_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.attachments.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            destroyPermanently(attachment) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.attachments.destroy-permanently', attachment.id));
                }
            },
            restore(attachment) {
                this.$inertia.get(this.route('admin.attachments.restore', attachment.id));
            },
            getExportUrl(format) {
                return this.route('admin.attachments.export', {format: format, ...this.filters});
            }
        },
    }
</script>